// components/AchievementProgressBarSVG.jsx
import React from "react";
import PropTypes from "prop-types";

const AchievementProgressBarSVG = ({ offset = 0 }) => (
  <svg
    width="715px"
    height="50px"
    viewBox="0 0 715 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
      <g id={2} transform="translate(-323.000000, -53.000000)">
        <g id="ProgressBar" transform="translate(323.000000, 53.000000)">
          <rect
            id="count_1"
            stroke="#FFFFFF"
            strokeWidth={3}
            transform="translate(357.500000, 25.000000) scale(1, -1) translate(-357.500000, -25.000000) "
            x="1.5"
            y="1.5"
            width={712}
            height={47}
            rx="23.5"
          />
          <rect
            id="count_2"
            fill="#FFFFFF"
            transform="translate(358.000000, 25.000000) scale(1, -1) translate(-358.000000, -25.000000) "
            x={12}
            y={12}
            // width={692}
            width={`${Math.ceil((692 / 100) * offset)}`}
            height={26}
            rx={13}
          />
        </g>
      </g>
    </g>
  </svg>
);

AchievementProgressBarSVG.propTypes = {
  offset: PropTypes.number,
};

export default AchievementProgressBarSVG;
